import { useQuery } from "react-query";
import { fetchWorkspaceUsers } from "@/services/workspaces";
/** Query hook for users who can be assigned tasks in a workspace. */
export function useWorkspaceUsers(workspaceId) {
  return useQuery(["workspace-users", workspaceId], function () {
    return fetchWorkspaceUsers(workspaceId);
  }, {
    enabled: Boolean(workspaceId),
    staleTime: 5 * 60 * 1000
  });
}